import { lazy } from 'react';
import { reloadPage } from 'app/lib/dom';

const RELOADED_KEY = 'lazyWithRetry:reloaded';

type Factory = Parameters<typeof lazy>[0];

async function load(factory: Factory) {
    try {
        const module = await factory().catch(() =>
            new Promise((resolve) => setTimeout(resolve, 1000)).then(factory)
        );
        sessionStorage.removeItem(RELOADED_KEY);
        return module;
    } catch (error) {
        if (sessionStorage.getItem(RELOADED_KEY)) {
            throw error;
        }
        sessionStorage.setItem(RELOADED_KEY, 'true');
        reloadPage();
        return new Promise<never>(() => {});
    }
}

export function lazyWithRetry(factory: Factory) {
    return lazy(() => load(factory));
}
